export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

const STORAGE_KEY = 'pg_utm_params';

export function extractFromQuery(query) {
  if (!query) return null;
  const params = {};
  let found = false;
  UTM_KEYS.forEach(key => {
    if (query[key]) {
      params[key] = String(query[key]);
      found = true;
    }
  });
  return found ? params : null;
}

export function saveToStorage(params) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));
  } catch (_) {
    // sessionStorage indisponível (modo privado restrito, etc)
  }
}

export function loadFromStorage() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

export function clearFromStorage() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    // noop
  }
}

export function toDataLayerObject(params) {
  if (!params) return {};
  const obj = {};
  UTM_KEYS.forEach(key => {
    if (params[key]) obj[key] = params[key];
  });
  return obj;
}

export function toQueryString(params) {
  if (!params) return '';
  const parts = UTM_KEYS
    .filter(key => params[key])
    .map(key => `${key}=${encodeURIComponent(params[key])}`);
  return parts.length ? '?' + parts.join('&') : '';
}
